import { render, staticRenderFns } from "./file-card-display.vue?vue&type=template&id=26dc0e2a"
import script from "./file-card-display.ts?vue&type=script&lang=ts&external"
export * from "./file-card-display.ts?vue&type=script&lang=ts&external"
import style0 from "./file-card-display.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26dc0e2a')) {
      api.createRecord('26dc0e2a', component.options)
    } else {
      api.reload('26dc0e2a', component.options)
    }
    module.hot.accept("./file-card-display.vue?vue&type=template&id=26dc0e2a", function () {
      api.rerender('26dc0e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/create-in-year-budget-request/create-iybr-form/files-change-request/file-card-display/file-card-display.vue"
export default component.exports